import { render, staticRenderFns } from "./getting-started.vue?vue&type=template&id=c1627a46&scoped=true&"
import script from "./getting-started.vue?vue&type=script&lang=js&"
export * from "./getting-started.vue?vue&type=script&lang=js&"
import style0 from "./getting-started.vue?vue&type=style&index=0&id=c1627a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1627a46",
  null
  
)

export default component.exports